import { lazy } from 'react';

const DescriptionItem = lazy(() => import('./DescriptionItem'));

export { DescriptionItem };
